import { render, staticRenderFns } from "./SickLeaveNoticeModalCreation.vue?vue&type=template&id=4f05bc28&scoped=true&"
import script from "./SickLeaveNoticeModalCreation.vue?vue&type=script&lang=ts&"
export * from "./SickLeaveNoticeModalCreation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f05bc28",
  null
  
)

export default component.exports